import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

function ProgressBar() {
    return (
        <div className="progressbar">
            <LinearProgress />
        </div>
    )
}

export default ProgressBar;